import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { setForm } from '../../Redux/Actions/formsActions';

const Pencil = props => {
  const selectClicked = data => {
    props.onSetForm(data);
  };

  return (
    <FontAwesomeIcon
      icon={faEdit}
      onClick={() => selectClicked(props.row.original)}
    />
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSetForm: data =>
    dispatch(setForm({ ...data, isEditing: true }, ownProps.model)),
});

export default connect(
  null,
  mapDispatchToProps,
)(Pencil);
